module.exports = __webpack_public_path__ + "static/img/qmwallet2-life_privileges_bg.c79ac131.png";